import { render, staticRenderFns } from "./PartyList.vue?vue&type=template&id=20810712&scoped=true"
import script from "./PartyList.vue?vue&type=script&lang=js"
export * from "./PartyList.vue?vue&type=script&lang=js"
import style0 from "./PartyList.vue?vue&type=style&index=0&id=20810712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20810712",
  null
  
)

export default component.exports